function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import './GacInputField.less';
import { fetchSuggestions } from './GacUtils';
import { debounce } from '../../utils/debounce';
function getSuggestionValue(suggestion) {
  return suggestion.name;
}
function renderSectionTitle(section) {
  return regionTranslations[section.title];
}
function getSectionSuggestions(section) {
  return section.items;
}
var regionTranslations = {
  region: 'Bundesländer',
  city: 'Ort',
  quarter: 'Viertel',
  postcodeWithQuarter: 'PLZ',
  postcode: 'PLZ',
  district: 'Kreis',
  quarterOrTown: 'Bezirke und Gemeinden'
};
var ENTER_KEY = 13;
export var GacInputField = /*#__PURE__*/function (_React$Component) {
  function GacInputField(props) {
    var _props$selectedSugges;
    var _this;
    _classCallCheck(this, GacInputField);
    _this = _callSuper(this, GacInputField, [props]);
    _defineProperty(_this, "inputRef", void 0);
    _defineProperty(_this, "containerRef", void 0);
    _defineProperty(_this, "fetchSuggestionsDebounced", void 0);
    _this.state = {
      value: ((_props$selectedSugges = props.selectedSuggestion) === null || _props$selectedSugges === void 0 ? void 0 : _props$selectedSugges.name) || '',
      suggestions: [],
      showCloseIcon: false
    };
    _this.fetchSuggestionsDebounced = debounce(function (_ref) {
      var value = _ref.value;
      return _this.onSuggestionsFetchRequested({
        value: value
      });
    }, 100);
    _this.onChange = _this.onChange.bind(_this);
    _this.renderInputComponent = _this.renderInputComponent.bind(_this);
    _this.onSuggestionSelected = _this.onSuggestionSelected.bind(_this);
    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.renderSuggestion = _this.renderSuggestion.bind(_this);
    _this.onInputFocus = _this.onInputFocus.bind(_this);
    _this.clearInput = _this.clearInput.bind(_this);
    _this.handleOnBodyClick = _this.handleOnBodyClick.bind(_this);
    _this.hideClearIcon = _this.hideClearIcon.bind(_this);
    _this.inputRef = /*#__PURE__*/React.createRef();
    _this.containerRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(GacInputField, _React$Component);
  return _createClass(GacInputField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.keepFocus ? this.removeInputFocus() : this.addInputFocus();
      if (this.props.closeIcon) {
        var body = document.getElementsByTagName('body')[0];
        body.addEventListener('click', this.handleOnBodyClick);
      }
    }
  }, {
    key: "handleOnBodyClick",
    value: function handleOnBodyClick(e) {
      var _this$containerRef;
      if (!this.state.showCloseIcon || !e.target) {
        return;
      }
      if (!((_this$containerRef = this.containerRef) !== null && _this$containerRef !== void 0 && (_this$containerRef = _this$containerRef.current) !== null && _this$containerRef !== void 0 && _this$containerRef.contains(e.target))) {
        this.setState({
          showCloseIcon: false
        });
      }
    }
  }, {
    key: "onChange",
    value: function onChange(event, _ref2) {
      var newValue = _ref2.newValue;
      this.setState({
        value: newValue
      });
      if (this.props.onSetSuggestionInputError) {
        this.props.onSetSuggestionInputError(!newValue || newValue.trim().length === 0);
      }
      if (newValue && newValue.length > 0) {
        this.setState({
          showCloseIcon: true
        });
      } else {
        this.setState({
          showCloseIcon: false
        });
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this$inputRef;
      (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || (_this$inputRef = _this$inputRef.current) === null || _this$inputRef === void 0 || _this$inputRef.focus();
    }
  }, {
    key: "clearInput",
    value: function clearInput() {
      var _this2 = this;
      this.setState({
        value: ''
      });
      setTimeout(function () {
        return _this2.addInputFocus();
      }, 0);
    }
  }, {
    key: "onInputFocus",
    value: function onInputFocus() {
      this.setState({
        suggestions: []
      });
      this.hideClearIcon();
      this.props.onFocus && this.props.onFocus();
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: "hideClearIcon",
    value: function hideClearIcon() {
      if (this.props.closeIcon) {
        var _this$getValue;
        this.setState({
          showCloseIcon: ((_this$getValue = this.getValue()) === null || _this$getValue === void 0 ? void 0 : _this$getValue.length) > 0
        });
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      if (event.keyCode === ENTER_KEY) {
        event.preventDefault();
        if (!this.state.value && this.props.onSetSuggestionInputError) {
          this.props.onSetSuggestionInputError(true);
          return;
        }
      }
    }
  }, {
    key: "onSuggestionSelected",
    value: function onSuggestionSelected(event, _ref3) {
      var suggestion = _ref3.suggestion;
      this.props.onSuggestionSelected(suggestion);
      this.setState({
        showCloseIcon: false
      });
    }
  }, {
    key: "onSuggestionsFetchRequested",
    value: function () {
      var _onSuggestionsFetchRequested = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref4) {
        var value, apiEndpoint, url, suggestions;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              value = _ref4.value;
              apiEndpoint = this.props.apiEndPoint;
              url = "".concat(apiEndpoint, "/searchlocation?query=").concat(encodeURIComponent(value));
              if (!this.props.nextgenData) {
                url += "&nextgendata=".concat(this.props.nextgenData);
              }
              _context.n = 1;
              return fetchSuggestions(value, url);
            case 1:
              suggestions = _context.v;
              this.setState({
                suggestions: suggestions
              });
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function onSuggestionsFetchRequested(_x) {
        return _onSuggestionsFetchRequested.apply(this, arguments);
      }
      return onSuggestionsFetchRequested;
    }()
  }, {
    key: "renderSuggestion",
    value: function renderSuggestion(suggestion) {
      var matches = match(suggestion.name, this.state.value.trim());
      var parts = parse(suggestion.name, matches);
      return /*#__PURE__*/React.createElement("span", null, parts.map(function (part, index) {
        var className = part.highlight ? 'highlight' : '';
        return /*#__PURE__*/React.createElement("span", {
          className: className,
          key: index
        }, part.text);
      }));
    }
  }, {
    key: "renderInputComponent",
    value: function renderInputComponent(inputProps) {
      return /*#__PURE__*/React.createElement("div", {
        className: "grid-item input-text-container"
      }, this.props.locationIcon ? /*#__PURE__*/React.createElement("span", {
        className: "input-icon-left absolute-content is24-icon-location"
      }) : this.props.icon && /*#__PURE__*/React.createElement("span", {
        className: "input-icon-left absolute-content is24-icon-search"
      }), this.props.closeIcon && this.state.showCloseIcon && /*#__PURE__*/React.createElement("div", {
        onClick: this.clearInput
      }, /*#__PURE__*/React.createElement("span", {
        className: "input-icon-right absolute-content cursor-pointer is24-icon-closing closeIcon"
      })), /*#__PURE__*/React.createElement("input", _extends({
        id: "search-input-makler"
      }, inputProps, {
        ref: this.inputRef,
        readOnly: this.props.readonly ? true : false
      })));
    }
  }, {
    key: "removeInputFocus",
    value: function removeInputFocus() {
      var _this$inputRef$curren;
      (_this$inputRef$curren = this.inputRef.current) === null || _this$inputRef$curren === void 0 || _this$inputRef$curren.blur();
    }
  }, {
    key: "addInputFocus",
    value: function addInputFocus() {
      var _this$inputRef$curren2;
      (_this$inputRef$curren2 = this.inputRef.current) === null || _this$inputRef$curren2 === void 0 || _this$inputRef$curren2.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        value = _this$state.value,
        suggestions = _this$state.suggestions;
      var props = {
        placeholder: this.props.placeholder || 'Ort order PLZ',
        onChange: this.onChange,
        onFocus: this.onInputFocus,
        className: "input-text one-whole ".concat(this.props.suggestionInputError && 'border border-error', " ").concat(this.props.hoverFocusDisabled && 'disableHoverFocus'),
        value: value,
        onKeyDown: this.onKeyDown
      };
      return /*#__PURE__*/React.createElement("div", {
        id: this.props.id,
        ref: this.containerRef,
        className: this.props.className
      }, /*#__PURE__*/React.createElement(Autosuggest, {
        multiSection: true,
        highlightFirstSuggestion: true,
        suggestions: suggestions,
        onSuggestionsFetchRequested: this.fetchSuggestionsDebounced,
        renderSuggestion: this.renderSuggestion,
        renderSectionTitle: renderSectionTitle,
        getSectionSuggestions: getSectionSuggestions,
        onSuggestionSelected: this.onSuggestionSelected,
        onSuggestionsClearRequested: function onSuggestionsClearRequested() {
          return 0;
        },
        getSuggestionValue: getSuggestionValue,
        renderInputComponent: this.renderInputComponent,
        inputProps: props,
        focusInputOnSuggestionClick: false
      }));
    }
  }]);
}(React.Component);